<template>
    <section class="section has-text-centered">
        <div class="container is-narrow">
            <div class="box has-shadow">
                <div class="content">
                    <div class="columns is-centered">
                        <div class="column">
                            <figure class="icon">
                                <i class="fa fa-money"></i>
                            </figure>
                            <h1 class="title is-size-4 is-spaced">Доверие</h1>
                            <hr />
                            <p>Lorem ipsum dolor sit nima qilsayam shu yaxshida tugrimi oshnalar? Вот такие вот у нас доступные цены</p>
                            <p>Lorem ipsum dolor sit nima qilsayam shu yaxshida tugrimi oshnalar? Вот такие вот у нас доступные цены</p>
                            <button class="button is-info is-inverted">Подробнее</button>
                            <div class="separator"></div>
                        </div>
                        <div class="column">
                            <figure class="icon">
                                <i class="fa fa-money"></i>
                            </figure>
                            <h1 class="title is-size-4 is-spaced">Доступные цены</h1>
                            <hr />
                            <p>Lorem ipsum dolor sit nima qilsayam shu yaxshida tugrimi oshnalar? Вот такие вот у нас доступные цены</p>
                            <p>Lorem ipsum dolor sit nima qilsayam shu yaxshida tugrimi oshnalar? Вот такие вот у нас доступные цены</p>
                            <button class="button is-info is-inverted">Подробнее</button>
                            <div class="separator"></div>
                        </div>
                        <div class="column">
                            <figure class="icon">
                                <i class="fa fa-money"></i>
                            </figure>
                            <h1 class="title is-size-4 is-spaced">Доступные цены</h1>
                            <hr />
                            <p>Lorem ipsum dolor sit nima qilsayam shu yaxshida tugrimi oshnalar? Вот такие вот у нас доступные цены</p>
                            <p>Lorem ipsum dolor sit nima qilsayam shu yaxshida tugrimi oshnalar? Вот такие вот у нас доступные цены</p>
                            <button class="button is-info is-inverted">Подробнее</button>
                            <div class="separator"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Features"
    }
</script>

<style scoped>

</style>